import { dscvrIcApi } from '@/shared/api';
import { useMutation } from '@tanstack/vue-query';

export const useCreateCurrencyPaymentLinkMutation = () => {
  return useMutation({
    mutationKey: ['create-currency-payment-link-mutation'],
    mutationFn: dscvrIcApi.igc.createCurrencyPaymentLink,
  });
};
